module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Snare Normal-52fbfdf3315c17c576547e49f38a2f62.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Snare Normal.mp3
// module id = 58
// module chunks = 0